module.exports = require('./helpers/bundle-url').getBundleURL('2LpMj') + "drawer_background.96c1190a.png" + "?" + Date.now();